import React, { useEffect, useState } from "react";
import { AiFillPayCircle, AiOutlineClear, AiFillApple } from "react-icons/ai";
import "../components/Cart/cart.css";
import { MyGlobalContext } from "../Context";
import EmptyCart from "../components/Cart/EmptyCart";
import CartArticle from "../components/Cart/CartArticle";
import CartPayment from "../components/Cart/Payment/CartPayment";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const Cart = () => {
  const {
    localCart,
    ClearCart,
    totalPrice,
    isPaymentTrue,
    setIsPaymentTrue,
    token,
  } = MyGlobalContext();

  const toastMsg = "Need to login then you can pay!";
  const toastStyle = {
    position: "top-center",
    autoClose: 2000,
  };

  // this useEffect for "AOS"
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  if (localCart.length === 0) {
    return <EmptyCart />;
  }
  return (
    <div className="cart-all">
      <h1 className="text-2xl text-black text-center">Your Products</h1>
      <div className="underlines"></div>
      <section className="cart-section">
        {localCart.map((myAll) => (
          <CartArticle key={myAll.id} {...myAll} />
        ))}
      </section>
      <hr />
      <div className="flex-total">
        <h3 className="h2">Total</h3>
        <h4 className="h2">${totalPrice}</h4>
      </div>
      <div className="clear-list-cart">
        <Link to={`${token.length !== 0 ? "" : "/login"}`}>
          <button
            onClick={() => {
              if (token.length !== 0) {
                setIsPaymentTrue(true);
              } else {
                toast.warn(toastMsg, toastStyle);
              }
            }}
            className="faApple flex flex-wrap justify-center"
          >
            <AiFillApple /> Pay Now
            <span className=" bg-white rounded-[50%] h-10 w-10 text-black flex justify-center items-center shadow-inner shadow-slate-400 ml-2 text-[13px] pay-amount-float-btn">
              ${totalPrice}
            </span>
          </button>
        </Link>
        <button onClick={ClearCart} className="faApple">
          Clear cart <AiOutlineClear />
        </button>
      </div>
      {isPaymentTrue && <CartPayment setIsPaymentTrue={setIsPaymentTrue} />}
    </div>
  );
};

export default Cart;
